import React, { useContext, createContext } from "react";
import * as ls from "local-storage";
import stores from "src/stores";
// import { swalError } from "src/utils/swal";
import { localStorageKeys } from "src/utils/constant";

export interface IAuthContext {
  token: () => string;
  user: () => any;
  signin: (authCode: string, cb: () => void) => void;
  signout: (cb: () => void) => void;
  clear: () => void;
}

const authContext = createContext({} as IAuthContext);

export const useAuth = (): IAuthContext => {
  return useContext(authContext);
};

export const useProvideAuth = (): IAuthContext => {
  const token = (): string => {
    return ls.get(localStorageKeys.KEY_TOKEN);
  };

  const user = () => {
    const json: any = ls.get(localStorageKeys.KEY_USER);
    if (typeof json === "string") {
      return JSON.parse(json);
    }

    return json;
  };

  const signin = async (authCode: string, cb: () => void) => {
    // const { user } = stores;

    try {
      // const data = await user.login(username, password);
      // if (data) {
      //   ls.set(localStorageKeys.KEY_TOKEN, data.token);
      //   ls.set(localStorageKeys.KEY_USER, {
      //     ...data.userInfo,
      //     loginDate: new Date(),
      //   });
      //   ls.set(localStorageKeys.KEY_PERMISSION, data.permissions);
        if (cb) {
          cb();
        }
      // } else {
      //   // swalError("Invalid token.");
      // }
    } catch (error) {
      const { response } = error;
      if (response && response.data) {
        // swalError(response.data.message || systemMessage.en.somethingWrong);
      } else {
        // swalError("Technical error!");
      }
    }
  };

  const signout = async (cb: () => void) => {
    // const { user } = stores;
    const token = ls.get(localStorageKeys.KEY_TOKEN);
    const isSuccess = !!token;

    if (token) {
      // isSuccess = await user.logout();
    }

    if (isSuccess) {
      clear();
      if (cb) {
        cb();
      }
    }
  };

  const clear = () => {
    ls.remove(localStorageKeys.KEY_TOKEN);
    ls.remove(localStorageKeys.KEY_USER);
    ls.remove(localStorageKeys.KEY_PERMISSION);
  };

  return {
    token,
    user,
    signin,
    signout,
    clear,
  };
};

export const ProvideAuth = ({ children }) => {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
};
